// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"fa386b44","263":"032b52f5","644":"8a8429b2"}[chunkId] + ".chunk.js";
};